import { render, staticRenderFns } from "./question-set-column.vue?vue&type=template&id=59a0d1c2&scoped=true&"
import script from "./question-set-column.vue?vue&type=script&lang=js&"
export * from "./question-set-column.vue?vue&type=script&lang=js&"
import style0 from "./question-set-column.vue?vue&type=style&index=0&id=59a0d1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0d1c2",
  null
  
)

export default component.exports